import { http } from "utils/http";

export const getData = (baseURL=undefined,url,params={}) => http({
    baseURL,
    url,
    method: 'get',
    params:{
        ...params
    }
}).then((res) => {
    
    return res.data
}).catch((err) => {
   
    return Promise.reject( err);
});